import React, { Fragment } from "react";
import { Badge }  from "reactstrap";
import moment from 'moment'

import TaskImg from "~/assets/images/task/task.png"


const TaskCard = ({item})=> {

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");

  return (
    <Fragment>
      <img src={TaskImg} />

      <div className="item-details">
        <div>
          <h6>  {item.title} </h6>
          <Badge color="points">  POINTS: {item.points} </Badge>
        </div>
        <div className="text-right">
          <h6> {formatDate(item.claimedAt)} </h6>
          <Badge color="custom-completed"> COMPLETED </Badge>
        </div>
      </div>
    </Fragment>
  );
};


export default TaskCard;
